import React from 'react';
import { Container } from './styles';
import { ReactComponent as Questions } from 'assets/questionRight.svg';
import { ReactComponent as Download } from 'assets/downloadRight.svg';
import useModal from 'utils/hooks/useModal';
import useResponsive from 'utils/hooks/useResponsive';
import { useTranslation } from 'react-i18next';
import Helper from './Helper';

const MsgHelpers = () => {

  const { t } = useTranslation()

  const { isTabLand } = useResponsive();
  const { TYPE_MODALS_DOWNLOAD, handleOpenModal } = useModal();

  const handleClick = () => handleOpenModal(TYPE_MODALS_DOWNLOAD.empty)

  return (
    <Container isTabLand={isTabLand}>
      <Helper
        to='/faqs'
        title={t('faqs')}
        icon={Questions}
      />

      <Helper
        onClick={handleClick}
        title={t('downloadApp')}
        icon={Download}
      />
    </Container>
  )
};

export default MsgHelpers;
